// Constant for stashing spotify oauth state in local storage.
export const OAUTH_STATE_KEY = "sss-oauth-state-key";

// Constant for stashing spotify oauth response in local storage.
export const OAUTH_RESPONSE_KEY = "sss-oauth-response-key";
